<template>
  <div>
    <main-layout />
    <vhp-dialog title="📢 공지사항" id="popup" class="popup" ref="popupDialog" no-gutters hideClose>
      <template v-slot:content>
        <div style="min-width:360px; max-width:calc(100vw - 24px); width:480px; border-top: 1px solid #3a3a3c15;" class="py-8">
          <!-- 새로운 팝업 시스템 (이미지 + 링크) -->
          <div v-if="popupData" class="popup-image-container">
            <img
              :src="popupData.imageUrl"
              alt="팝업 이미지"
              class="popup-image"
              :class="{ 'clickable': popupData.linkUrl }"
              @click="handlePopupClick"
            />
          </div>
          
          <!-- 기존 Content 팝업 (하위 호환성) -->
          <div v-else-if="popupContent" v-html="popupContent.content"/>
        </div>
      </template>

      <template v-slot:action>
        <div class="row" style="justify-content:space-between; border-top: 1px solid #3a3a3c15;">
          <button class="vhp-button" style="width:50%; background:transparent;" @click="hideForToday">
            {{ $t("오늘 하루 보지 않기") }}
          </button>

          <button class="vhp-button" style="width:50%; background:transparent; border-left:  1px solid #3a3a3c15;" @click="$refs.popupDialog.close()">
            {{ $t("닫기") }}
          </button>
        </div>
      </template>
    </vhp-dialog>
  </div>
</template>

<script>
import MainLayout from "@/components/layouts/MainLayout.vue";

export default {
  name: "MainPage",
  components: { MainLayout },
  data() {
    return {
      isPopup: true,
      popupContent: null, // 기존 Content 팝업 (하위 호환성)
      popupData: null, // 새로운 Popup 모델
    };
  },
  mounted() {
    this.getPopup()
  },
  methods: {
    hideForToday() {
      const now = new Date();
      const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      localStorage.setItem('hideNoticeUntil', tomorrow.toISOString());
      this.$refs.popupDialog.close()
    },

    handlePopupClick() {
      if (this.popupData && this.popupData.linkUrl) {
        // 외부 링크인지 내부 링크인지 확인
        if (this.popupData.linkUrl.startsWith('http://') || this.popupData.linkUrl.startsWith('https://')) {
          window.open(this.popupData.linkUrl, '_blank');
        } else {
          // 내부 링크인 경우 라우터로 이동
          this.$router.push(this.popupData.linkUrl);
        }
        this.$refs.popupDialog.close();
      }
    },

    async getPopup() {
      const key = 'hideNoticeUntil';
      const hideUntil = localStorage.getItem(key);
      const now = new Date();

      // 오늘 하루 보지 않기 체크
      if (hideUntil && new Date(hideUntil) > now) {
        return;
      }

      try {
        // 새로운 팝업 시스템 우선 조회
        const popupRes = await this.$axios.get('/popup');
        if (popupRes.status === 200 && popupRes.data) {
          this.popupData = popupRes.data;
          this.imageLoadError = false; // 이미지 에러 플래그 초기화
          this.$refs.popupDialog.load();
          return;
        }
      } catch (err) {
        // 팝업이 없거나 에러인 경우 기존 시스템으로 폴백
        console.log('새 팝업 시스템 조회 실패, 기존 시스템으로 폴백:', err);
      }

      // 기존 Content 팝업 조회 (하위 호환성)
      try {
        const contentRes = await this.$axios.get('/content/popup', {
          params: {
            locale: this.$i18n.locale.toUpperCase()
          }
        });
        if (contentRes.data) {
          this.popupContent = contentRes.data;
          this.$refs.popupDialog.load();
        }
      } catch (err) {
        console.log('기존 팝업 조회 실패:', err);
      }
    }
  }
};
</script>

<style lang="scss" src="./index.scss"></style>
